import { createElement, Fragment } from "react";
/**
 * External Dependencies
 */
import { css } from 'emotion';
import classnames from 'classnames';

/**
 * Internal Dependencies
 */
import { __experimentalUseFieldRenderContext } from '../field-render/context';
import useBlockTheme from '../../hooks/use-block-theme';
const BlockCustomHTML = () => {
  const {
    attributes
  } = __experimentalUseFieldRenderContext();
  const theme = useBlockTheme(attributes?.themeId);
  return createElement(Fragment, null, attributes?.customHTML && createElement("div", {
    className: classnames('renderer-components-block-custom-html', css`
							color: ${theme.questionsColor};
						`),
    dangerouslySetInnerHTML: {
      __html: attributes?.customHTML
    }
  }));
};
export default BlockCustomHTML;
//# sourceMappingURL=index.js.map